module.exports = __webpack_public_path__ + "static/img/select-your-recipients.42d56db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/select-your-recipients.png
// module id = EZD8
// module chunks = 0